export default {
  feedback: {
    token_required: 'Veuillez cocher la case pour confirmer que vous êtes humain',
    frequent_requests:
      "Veuillez vérifier vos SMS. Nous avons déjà envoyé le code au numéro indiqué par SMS. Si ce n'est pas le cas, vérifiez le numéro de téléphone ou réessayez dans 10 minutes.",
  },
};
